import styled from 'styled-components'

const CalendarContainer = styled.div`${props => `
  flex: 1;
  text-align: center;
  padding-bottom: ${props.theme.rem()};
`}`

export { CalendarContainer }